export default __webpack_public_path__ + "static/media/demonfamiliar.07df2fef.png";